export default "__VITE_ASSET__c8ac0f46__"